module.exports = __webpack_public_path__ + "media/img/autoplac_banner-e626cce2.png";